
$(".kostenrechner_steps>div").on("click", "i", function(){
    $(this).removeClass("step_number").addClass("fa fa-check-circle").html("");
});
